// Single source of truth for field reading metrics and their alert ranges.
export interface MetricDef {
  key: string;
  label: string;
  unit: string;
  warn: [number, number]; // outside → warning
  crit: [number, number]; // outside → alert
}

export const FIELD_METRICS: MetricDef[] = [
  { key: "temperature", label: "Temperature", unit: "°C", warn: [0, 30], crit: [-5, 35] },
  { key: "ph", label: "pH", unit: "pH", warn: [6.5, 8.5], crit: [6, 9] },
  { key: "dissolved_oxygen", label: "Dissolved oxygen", unit: "mg/L", warn: [5, 14], crit: [3, 20] },
  { key: "turbidity", label: "Turbidity", unit: "NTU", warn: [0, 5], crit: [0, 10] },
  { key: "conductivity", label: "Conductivity", unit: "µS/cm", warn: [0, 1500], crit: [0, 2500] },
  { key: "voc", label: "VOC", unit: "ppm", warn: [0, 50], crit: [0, 100] },
];

export type ReadingStatus = "normal" | "warning" | "alert";

export function classifyReading(metricKey: string, value: number): ReadingStatus {
  const m = FIELD_METRICS.find((x) => x.key === metricKey);
  if (!m) return "normal";
  if (value < m.crit[0] || value > m.crit[1]) return "alert";
  if (value < m.warn[0] || value > m.warn[1]) return "warning";
  return "normal";
}
